<template>
    <div class="base-gift-pack" :class="{'pack-sp': $store.state.screen == 1}">
        <div class="header">
            <div class="item" :class="{isitem: activeNav == index}" v-for="(item, index) in navList" :key="index" @click="onNav(index)">{{item}}</div>
        </div>
        <div v-show="activeNav == 0">
            <div v-if="isblank == true && list.length > 0">
                <div class="list" v-for="(item, index) in list" :key="index">
                    <div class="content" @click="$router.push('/base-gift-pack-details?id=' + item.pid)">
                        <div class="title">{{item.pack_name}}</div>
                        <div class="detl">礼包内容：{{item.pack_abstract}}</div>
                        <div class="scale">
                            <div>礼包剩余：</div>
                            <div class="process-bg">
                                <div class="process" :style="{width: getScale(item.pack_get_counts, item.pack_counts) + '%'}"></div>
                            </div>
                            <div class="percentage">{{getScale(item.pack_get_counts, item.pack_counts)}}%</div>
                        </div>
                    </div>
                    <div class="btn" :class="{isbtn: item.status == 0 && item.type == 0}" @click="onReceive(item)">
                        <span v-if="item.is_vip == 1">VIP领取</span>
                        <span v-else>领取</span>
                    </div>
                </div>
            </div>
            <div class="theblank" v-if="isblank == true && list.length <= 0">
                <TheBlank />
            </div>
        </div>
        <div v-show="activeNav == 1">
            <div v-if="isblank == true && getList.length > 0">
                <div class="list" v-for="(item, index) in getList" :key="index">
                    <div class="content" @click="$router.push('/base-gift-pack-details?id=' + item.pid + '&code=' + item.card)">
                        <div class="title">{{item.pack_name}}</div>
                        <div class="detl gift">礼包码：{{item.card}}</div>
                        <div class="scale">使用时段：{{item.use_time | dateTime}}~{{item.finsh_time | dateTime}}</div>
                    </div>
                    <div class="btn copy" @click="onCopy(item.card)">复制</div>
                </div>
            </div>
            <div class="theblank" v-if="isblank == true && getList.length <= 0">
                <TheBlank />
            </div>
        </div>
        <transition name="component-fade" mode="out-in">
            <BaseSuccess :cardNum='cardNum' @childSucce='childSucce' v-if="issucce" />
            <BaseError @childError='childError' v-if="iserror" />
            <TheTips :msg='msg' v-if="msg" />
        </transition>
    </div>
</template>

<script>
    import BaseSuccess from '@/views/BaseWelfare/BasePopup/BaseSuccess'
    import BaseError   from '@/views/BaseWelfare/BasePopup/BaseError'
    import Clipboard   from 'clipboard'
    import TheTips     from '@/components/TheTips'
    import moment      from 'moment'
    import TheBlank    from '@/components/TheBlank'

    export default {
        components: {
            BaseSuccess,
            BaseError,
            TheTips,
            TheBlank
        },
        data () {
            return {
                msg: null,
                navList: ['待领取', '已领取'],
                activeNav: 0,
                list: [],
                processNum: 0,
                issucce: false,
                iserror: false,
                accountData: {},
                pid: '',
                cardNum: '',
                getList: [],
                isblank: null,
                h5LoginData:{}
            }
        },
        computed: {
            getScale () {
                return (pack_used_counts, pack_counts) => {
                    if (pack_counts <= 0) {
                        return 0
                    } else {
                        return Number.parseInt(100 - (pack_used_counts / pack_counts) * 100)
                    }
                }
            }
        },
        filters: {
            dateTime (time) {
                return moment.unix(time).format('YYYY-MM-DD')
            }
        },
        methods: {
            onNav (index) {
                this.activeNav = index
            },
            childSucce (event) {
                this.issucce = event
            },
            // 领取礼包
            getNum () {
                let options = {
                    appid: this.accountData.appid,
                    channel: this.accountData.channel ? this.accountData.channel :this.h5LoginData.channel,
                    uid: this.accountData.uid,
                    pid: this.pid,
                    machine_code: this.h5LoginData.machine_code
                }
                options.sign = this.util.getSign(options, this.accountData.appkey)
                //发起请求
                this.$axios.post('https://sdk.gameschain.pro/index.php?g=api&m=package&a=getPackageCode', this.$qs.stringify(options)).then(res => {
                    if (res.data.status == 1) {
                        if(res.data.data) {
                            this.getPacks()
                            this.cardNum = res.data.data.card
                            this.issucce = true
                            // this.msg = '领取礼包码成功'
                            // setTimeout(() => {
                            //     this.msg = null
                            // }, 1000)
                        } else {
                            this.msg = '领取礼包码失败'
                            setTimeout(() => {
                                this.msg = null
                            }, 2000)
                        }
                    } else {
                        this.msg = res.data.msg
                        setTimeout(() => {
                            this.msg = null
                        }, 2000)
                    }
                }).
                catch(o => {
                    this.msg = '请求失败'
                    setTimeout(() => {
                        this.msg = null
                    }, 2000)
                })
            },
            onReceive (item) {
                this.pid = item.pid
                if (item.is_vip == 1) {
                    this.iserror = true
                } else {
                    this.getNum()
                }
            },
            childError (event) {
                this.iserror = event
            },
            onCopy (code) {
                let that = this
                let clipboard = new Clipboard('.copy', {
                    text () {
                        return code
                    }
                })
                clipboard.on("success", e => {
                    that.msg = '复制成功'
                    setTimeout(() => {
                        that.msg = null
                    }, 1000)
                    // 释放内存
                    clipboard.destroy()
                })
                clipboard.on("error", e => {
                    that.msg = '复制失败'
                    setTimeout(() => {
                        that.msg = null
                    }, 1000)
                    // 释放内存
                    clipboard.destroy()
                })
                clipboard.onClick(event)
            },
            // 获取礼包列表
            getPacks () {
                console.log('获取礼包列表',this.accountData)
                let options = {
                    appid: this.accountData.appid,
                    channel:this.accountData.channel ? this.accountData.channel :this.h5LoginData.channel,
                    uid: this.accountData.uid,
                    system: this.config.system,

                    // page: this.page,
                }
                options.sign = this.util.getSign(options, this.accountData.appkey)
                //礼包列表接口
                this.$axios.post("https://sdk.gameschain.pro/index.php?g=api&m=package&a=getPackageList", this.$qs.stringify(options)).then(res => {
                    if (res.data.status == 1) {
                        this.list = res.data.data.pack_list
                        this.getList = res.data.data.get_list
                        this.isblank = true
                        sessionStorage.setItem('setGift', JSON.stringify(res.data.data))
                    }
                })
            }
        },
        created () {
            this.accountData = JSON.parse(sessionStorage.getItem('accountData'))
            this.h5LoginData = JSON.parse(sessionStorage.getItem('h5LoginData'))
            console.log('h5LoginData',this.h5LoginData)
            console.log('setGift',sessionStorage.getItem('setGift'))
            if (sessionStorage.getItem('setGift')) {
                let setGift = JSON.parse(sessionStorage.getItem('setGift'))
                this.list = setGift.pack_list
                this.getList = setGift.get_list
                this.isblank = true
            } else {
                this.getPacks()
            }
        }
    }
</script>

<style lang="scss" scoped>
    $color: #FF6C22; // 主体颜色
    // 横屏css
    .base-gift-pack {
        margin-bottom: 60px;
        padding: 0 60px;
        overflow: hidden;
        transition: all 0.3s;
        .header {
            padding: 0 60px;
            margin-top: 30px;
            display: flex;
            justify-content: space-evenly;
            .item {
                width: 210px;
                height: 90px;
                font-size: 45px;
                color: rgba(255, 255, 255, 0.5);
                border-radius: 18px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .isitem {
                color: $color;
                border: 2px solid $color;
            }
        }
        .list {
            height: 225px;
            border-radius: 18px;
            background: rgba(255, 255, 255, 0.2);
            padding: 0 45px;
            margin-top: 30px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .content {
                flex: 1;
                font-size: 33px;
                color: rgba(255, 255, 255, 0.5);
                display: flex;
                flex-direction: column;
                justify-content: center;
                .title {
                    font-size: 48px;
                    color: #fff;
                }
                .detl {
                    width: 646px;
                    margin: 5px 0;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                .gift {
                    color: $color;
                }
                .scale {
                    display: flex;
                    align-items: center;
                }
                .process-bg {
                    width: 360px;
                    height: 24px;
                    border-radius: 12px;
                    background: rgba(255, 255, 255, 0.2);
                    overflow: hidden;
                    margin-top: 5px;
                }
                .process {
                    width: 0;
                    height: 24px;
                    border-radius: 12px;
                    background: $color;
                }
                .percentage {
                    margin: 5px 0 0 20px;
                }
            }
            .btn {
                width: 168px;
                height: 72px;
                font-size: 36px;
                border-radius: 18px;
                background: $color;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .isbtn {
                background: rgba(255, 255, 255, 0.5);
            }
        }
        .theblank {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }
    // 竖屏css
    .pack-sp {
        margin-bottom: 90px;
        padding: 0 90px;
        .header {
            padding: 0 90px;
            margin-top: 54px;
            .item {
                width: 380px;
                height: 163px;
                font-size: 81px;
                border-radius: 32px;
            }
            .isitem {
                border: 5px solid $color;
            }
        }
        .list {
            height: 409px;
            border-radius: 32px;
            padding: 0 81px;
            margin-top: 54px;
            .content {
                font-size: 60px;
                .title {
                    font-size: 87px;
                }
                .detl {
                    width: 950px;
                    margin: 9px 0;
                }
                .process-bg {
                    width: 450px;
                    height: 40px;
                    border-radius: 21px;
                    margin-top: 9px;
                }
                .process {
                    height: 40px;
                    border-radius: 21px;
                }
                .percentage {
                    margin: 9px 0 0 20px;
                }
            }
            .btn {
                width: 280px;
                height: 120px;
                font-size: 65px;
                border-radius: 32px;
            }
        }
    }
</style>